import React, {useState,useEffect} from 'react'
import {defaultSettings, ISettings} from '../modules/profile/components/settings/SettingsModel'
import {defaultAccount, IAccount} from './MyAccountModel'
import Popup from './Popup';
import './style.css';
import region from './address/region.json'
import city from './address/city.json'
import companyLogo from './Avision_Logo.png';
import {db, storage} from './firebase';
import {
  ref,
  onValue,
  push,
  update,
  remove
} from 'firebase/database';
import axios from 'axios';
import liff from '@line/liff';

import membercard from './membercard.png';
import {ReactSession } from 'react-client-session';
import {Routes, Route, useNavigate,useLocation} from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import {getStorage, ref as ref_storage, getDownloadURL ,listAll} from "firebase/storage";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  setDoc ,
   query,
   where,
   onSnapshot
} from "firebase/firestore";
import {useRef} from 'react';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
// import ReactDOM from 'react-dom';
import $ from 'jquery';
import JsBarcode from 'jsbarcode';
import QRCode from "react-qr-code";
import Col from 'react-bootstrap/Col';
import successlogo from './Otp/correct.png';
import failedlogo from './Otp/failed.png';
import { dowloadFile, getImageUrl } from '../utils/function-utils';
import { initialStore } from '../stores/init_config_store';


export function Login() {
    const usersCollectionRef = collection(db, "Member");
    const [ note, setNote ] = useState("")
    const [data, setData] = useState<IAccount>(defaultAccount)
    //const [hasError, setHasError] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenNotconnectBc, setIsOpenNotconnectBc] = useState(false);
    const [isOpenNotapp, setIsOpenNotapp] = useState(false);
    const navigate = useNavigate();
    const location = useLocation()
    const urlpath =location.pathname;

    //AVCDAPNF.0001  29/04/2025  Add code for ... Make reuse logo image
    const setLogo  = initialStore((state) => state.setLogo);
    //C-AVCDAPNF.0001  29/04/2025  Add code for ... Make reuse logo image



    const togglePopup = () => {
      setIsOpen(!isOpen);
    }

    const handleClick = async () => {
      console.log(data)
    }
    const togglePopupNotconnectBc = () => {
      //setIsOpenNotconnectBc(!isOpenNotconnectBc);
    }
    function popupNotconnectBc() {
      setIsOpenNotconnectBc(!isOpenNotconnectBc);
    }
    const togglePopupNotapp = () => {
      //setIsOpenNotconnectBc(!isOpenNotconnectBc);
    }
    function popupNotapp() {
      setIsOpenNotapp(!isOpenNotapp);
    }



    const [blogs,setBlogs]=useState([])
    const logout = () => {
      liff.logout();
      window.location.reload();
    }
    const [name, setName] = useState("");
    const [userLineID, setUserLineID] = useState("");
    const [pictureUrl, setPictureUrl] = useState("");
    const [userclub, setUserclub] = useState("");
    const [users, setUsers] = useState([]);
    const [totalcustomer, setTotalcustomer] = useState(0);
    const [snapShot, setSnapshot] = useState(null);
    const [ssnapShot1, setSSnapshot1] = useState("");
    useEffect(() => {
      /*setTimeout(() => {
          getAllData()
      }, 6000);*/
      const getAllData = async () => {
        await setfileconfig()
      //  await fetchLiff()
    //    await updatadata()
      };
        getAllData();
    //  fetchLiff();
    //  fetchchecklogin();
    //checkcustomerlogin();
    }, [])
    const [confirmdatasuc, setconfirmdatasuc] = useState<String>();
    function authenticateUser(user:string, password:string)
    {
        var token = user + ":" + password;
        var hash = btoa(token);
        return "Basic " + hash;
    }
    function checkcluburl(url:any)
    {
        const encoded = encodeURIComponent(url);
        return  encoded;
    }



    const [avsliffid, setavsliffid] = useState("");
    const [datasetup, setdatasetup] = useState('');
    const [checkcustomer, setcheckcustomer] = useState(false);

    async function setfileconfig() {
      let club = (new URLSearchParams(window.location.search)).get("Club_Code");
      let clubsection ="";
      console.log("clublogin",club);
      console.log(typeof club);


      let clubs= ""+club;
      if (club==null) {
          let clubcode = window.sessionStorage.getItem('Club_Code');
          if (clubcode) {

                 club = clubcode;
                 clubsection= clubcode;
          }
      }

      if (club) {
        console.log("clubsection",clubsection);
          let clubidweb="";
        if (clubsection!="") {
           clubidweb= ""+clubsection;
        }else{
          window.sessionStorage.setItem("Club_Code",clubs);
          const clubid = window.sessionStorage.getItem("Club_Code");

           clubidweb= ""+clubid;
        }
       if (clubidweb) {


      /* const storageRefdatacity= await ref_storage(storage, 'config_file/city.json');
         const cityfile = await getDownloadURL(storageRefdatacity).then((urldatacity) => {
         const resdatacity =  fetch(urldatacity)
        // .then(results => results.json())
         .then(response => response.json())
           .then(resdatacity=> {
              console.log("resdatacity",resdatacity);

           })
           .catch(err=> console.log(err))
         });  */
        //AVCDAAV.002  25/03/2025  Add code for  Add setup news config file
        const showEvent = window.sessionStorage.getItem("showEvent");
        if(showEvent) window.sessionStorage.removeItem("showEvent");
        const newsJson = await dowloadFile("config_news/news_setup.json");
        if ( newsJson ) {
          window.sessionStorage.setItem("setupNews", JSON.stringify(newsJson));
        }
         //C-AVCDAAV.002  25/03/2025  Add code for  Add setup news config file
        const storageRefdataconsent = await ref_storage(storage, 'config_file/consent_web.json');
        const consentfile =  await getDownloadURL(storageRefdataconsent).then((urldataconsent) => {
          const resdataconsent = fetch(urldataconsent)
          .then(response => response.json())
          .then((resdataconsent) => {
            // console.log(resdataconsent);
            window.sessionStorage.setItem("consent",JSON.stringify(resdataconsent));
          })
          .catch(err=> console.log(err))
        })
        const storageRefdataclub = await ref_storage(storage, 'config_file/club_scheme_web.json');
        const clubfile = await getDownloadURL(storageRefdataclub).then((urldataclub) => {
        const resdataclub =  fetch(urldataclub)
       // .then(results => results.json())
        .then(response => response.text())
          .then(resdataclub=> {
            window.sessionStorage.setItem("club_scheme",resdataclub);
          })
          .catch(err=> console.log(err))
      });
         const storageRefdatasetup = await ref_storage(storage, 'config_file/setup_web.json');
         const setupfile = await getDownloadURL(storageRefdatasetup).then((urldatasetup) => {
         const resdatasetup =   fetch(urldatasetup)
         .then(response => response.text())
         .then(resdatasetup=> {

            // setdatasetup(resdatasetup.data)
             window.sessionStorage.setItem("setupweb",resdatasetup);
              let setupweb = window.sessionStorage.getItem('setupweb');
              let setupwebconvert= ""+setupweb;
              const obj = JSON.parse(setupwebconvert);
              // console.log(obj);
              Object.entries(obj).map((value: any[]) => {
                  // console.log(value[1].club_code);
                  if (club==value[1].club_code) {
                    let liff_url = value[1]['liff_url'];
                    let result1 = liff_url.substr(21);

                    window.sessionStorage.setItem("setupwebdefault",JSON.stringify(value[1]));
                    const   avsliffid = result1;
                      window.sessionStorage.setItem("liffid",result1);


                  }

                  // if (liffweb) {
                  //      liff.init({ liffId: liffweb }) //console.log(res)=idlift

                  //     console.log("isInClient",liff.isInClient());
                  //     console.log("liff.getOS()",liff.getOS());


                  //     if (liff.isLoggedIn()) {
                  //       let getProfile =  await liff.getProfile();
                  //       console.log(getProfile);
                  //       setName(getProfile.displayName);
                  //       setUserLineID(getProfile.userId);
                  //       //  console.log(getProfile);
                  //       window.sessionStorage.setItem("linedata",getProfile.userId);

                  //     }else{
                  //       liff.login();
                  //     }
                  //     return;
                  // }else{
                  //   console.log("liff nonnn");

                  // }
              })
              const storageRefdatastyleup=  ref_storage(storage, 'config_file/style_setup_web.json');
              const styleSetupfile =  getDownloadURL(storageRefdatastyleup).then((urldataStyleSetup) => {
              const resdataStyleSetup =   fetch(urldataStyleSetup)
                .then(response => response.json())
                .then(async (resdatastylesetup) => {
                  const setupCheckStyle = JSON.parse(""+window.sessionStorage.getItem("setupwebdefault"));
                  //AVCDAPNF.0001  29/04/2025  Add code for ... Make reuse logo image
                  const imageLogo = await getImageUrl(setupCheckStyle.club_logo_path);
                  setLogo(imageLogo);
                  //C-AVCDAPNF.0001  29/04/2025  Add code for ... Make reuse logo image
                  // console.log(setupCheckStyle);
                  const styleSetup:any = {};
                  Object.entries(setupCheckStyle).forEach(valSet => {
                    Object.values(resdatastylesetup).map((val:any) => {
                      // console.log(valSet);
                      if(valSet[1] == val.style_code){
                        // console.log(valSet[0]);
                        // console.log(val);
                        styleSetup[valSet[0]] = val;
                      }
                    })
                  });
                  // console.log(styleSetup);
                  window.sessionStorage.setItem("stylesetup",JSON.stringify(styleSetup));

                  // const test222 = JSON.parse(""+window.sessionStorage.getItem("stylesetup"));
                  // console.log(test222.title_style);

                })
                .catch(error => console.log('error', error));

              })

              // return;

              const liffidweb = window.sessionStorage.getItem("liffid");
              let liffweb= ""+liffidweb;
                if (liffweb) {

                  liff.init({liffId: liffweb})
                  .then(async () => {
                    if (liff.isLoggedIn()) {
                      console.log("fggt4");
                      liff.getProfile()
                      .then((profile) => {
                      //  alert(liff.isInClient())
                        console.log("isInClient",liff.isInClient());
                        console.log("liff.getOS()",liff.getOS());
                        if (liff.isInClient()===false) {
                          //avnsd
                          popupNotapp()
                          return;
                          //avnsd
                        }


                        // let getProfile =  await liff.getProfile();
                        // console.log(getProfile);
                        setName(profile.displayName);
                        setUserLineID(profile.userId);
                        //  console.log(getProfile);
                        window.sessionStorage.setItem("linedata",profile.userId);
                        const storageRefdataconnection =  ref_storage(storage, 'config_file/connection_web.json');
                        const connectionfile =  getDownloadURL(storageRefdataconnection).then((urldataconnection) => {
                        const resdataconnection =  fetch(urldataconnection)
                        .then(response => response.json())
                          .then(resdataconnection=> {
                            //  console.log('5555',resdataconnection);
                            let linedata = window.sessionStorage.getItem('linedata');
                            let linedataconvert =""+linedata;
                            console.log('clubcode2',clubidweb);
                            console.log('linedatalog2',linedata);
                          //   setdatasetup(resdataconnection.data)
                            window.sessionStorage.setItem("connection",JSON.stringify(resdataconnection));
                            const connectionweb = JSON.parse(""+window.sessionStorage.getItem("connection"));
                            console.log(connectionweb);
                            console.log("ffff");
                      /*  //    "CR-STAFF_Uc78a52172035f182eaa27b9a52f1e033"
                          //  const q = query(collection(db, "Member"), where("line_user_id", "==", "Uc78a52172035f182eaa27b9a52f1e033"));


                            const q = query(collection(db, "Member"), where(documentId(), '==', 'CR-STAFF_Uc78a52172035f182eaa27b9a52f1e033'))
                            console.log("gg",q);
                            const museums = query(collection(db, 'Member'), where('line_user_id', '==', 'Uc78a52172035f182eaa27b9a52f1e033'));
                              const querySnapshot =  getDocs(museums);
                              querySnapshot.forEach((doc) => {
                                  console.log(doc.id, ' => ', doc.data());
                              });

                              return;*/
                              setcheckcustomer(true);

                              const datachecks = 0;
                                console.log("datachecks",datachecks);
                                console.log("clubidwebclubidweb",clubidweb);

                                // checkcluburl(clubidweb)
                                const q = query(collection(db, "Member"), where("line_user_id", "==", linedataconvert),where("club_code", "==",clubidweb ));
                              //  setSSnapShot1("123");


    //   console.log("unsuscribe",unsuscribe);




                      /*    getDocs(collection(db, "Member"))
                            .then((querySnapshot)=>{
                                const newData = querySnapshot.docs
                                    .map((doc) => ({...doc.data(), id:doc.id }));
                                    console.log("newData",newData);
                                    console.log("linedataconvert",linedataconvert);
                                    console.log("clubidweb",clubidweb);*/

                                    const unsuscribe = onSnapshot(q, (querySnapshot) => {
                                      const user = JSON.parse(""+window.sessionStorage.getItem("Customerdata"));
                                      if (user) {
                                        console.log("have Customerdata");

                                        return;
                                      }
                // setSnapShot(querySnapshot)
              //  console.log("querySnapshot",querySnapshot.docs[0]._document);
                //  console.log("querySnapshot",querySnapshot.docs[0]._document.data.value.mapValue.fields);
                //  const dataquerySnapshot =querySnapshot.docs[0]._document.data.value.mapValue.fields;

                //  console.log("querySnapshot",querySnapshot.docs[0]._document);
                //  const dataquerySnapshot = querySnapshot.docs[0];
                //  console.log("querySnapshot",dataquerySnapshot);

                  const dataonfirebase = querySnapshot.docs.map((d) => ({ id: d.id, ...d.data() }))
                  const val:any =dataonfirebase[0];
                //  console.log("urls",urls[0]);
          //   });
                                  //  newData.forEach(async (val:any, key:any) => {
                                  console.log("dataonfirebase",dataonfirebase);

                                        console.log("newData",dataonfirebase[0]);
                                        console.log("loginurlpath",urlpath);
                                      if (dataonfirebase[0]===undefined) {
                                           navigate('/verifymobile');
                                           return;
                                      }
                                        console.log(val['line_user_id']);
                                      if (val['line_user_id']==linedataconvert && val['club_code']==clubidweb) {
                                      //  setcheckcustomer(true);

                                          console.log("newData",dataonfirebase[0]);

                                          sessionStorage.setItem("Customerdata", JSON.stringify(dataonfirebase[0]));
                                          const user = JSON.parse(""+window.sessionStorage.getItem("Customerdata"));
                                          setcheckcustomer(false);
                                      /*  }
                                    })
                                console.log("lll", newData);
                            })*/

                        /*    var checkmemberfire =connectionweb[0].Web_Api_Endpoint+connectionweb[0].Web_Api_Get_Web_Member_Data+"?read=insight&userID="+linedataconvert+"&club_code="+checkcluburl(clubidweb);

                            const res =  fetch(checkmemberfire, {
                              headers: {
                          "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                          }
                          })
                          .then(results => results.json())
                          .then(res=>{
                          console.log("res",res);*/

                        /*  if (res.errors==true) {
                            console.log("checked member bc");


                            navigate('/verifymobile');


                          }else{*/
                            console.log("checked member bc");

                            //checked member bc

                                //check mobileNo
                              /*  if (res.response.data_member.mobile_phone_no) {
                                  console.log("res.response.data_member.mobile_phone_no",res.response.data_member.mobile_phone_no);

                                      var urlLicense =connectionweb[0].BC_Api_Endpoint+connectionweb[0].BC_Api_Get_Member+"?$filter=mobileNo eq '"+res.response.data_member.mobile_phone_no+"' and memberClub eq '"+clubidweb+"'";

                                }else{
                                    var urlLicense =connectionweb[0].BC_Api_Endpoint+connectionweb[0].BC_Api_Get_Member+"?$filter=lineUserId eq '"+linedataconvert+"' and memberClub eq '"+clubidweb+"'";
                                }*/
                              //  var urlLicense =connectionweb[0].BC_Api_Endpoint+connectionweb[0].BC_Api_Get_Member+"?$filter=lineUserId eq '"+linedataconvert+"' and memberClub eq '"+clubidweb+"'";


                              var urlLicense =connectionweb[0].BC_Api_Endpoint+connectionweb[0].BC_Api_Get_Member+"?$filter=mobileNo eq '"+user.mobile_phone_no+"' and memberClub eq '"+checkcluburl(clubidweb)+"'"+" and memberAccountNo eq '"+user.bc_account_no+"'"+" and lineUserId  eq '"+linedataconvert+"'";
                              console.log("urlLicense",urlLicense);





                                  var myHeaders = new Headers();
                                  myHeaders.append("Authorization", authenticateUser(connectionweb[0].BC_Api_Username,connectionweb[0].BC_Api_Password));

                                  fetch(urlLicense, {
                                    method: 'GET',
                                    headers: myHeaders,
                                    redirect: 'follow'
                                  })
                                .then(results => results.json())
                                .then(data => {

                                    console.log("data.value[0]",data.value[0]);

                                  if (data.value[0]!=null) {
                                    const createdata = data.value[0];
                                    sessionStorage.removeItem('Customerdata');
                                    sessionStorage.setItem("Customerdata", JSON.stringify(dataonfirebase[0]));
                                    const user = JSON.parse(""+window.sessionStorage.getItem("Customerdata"));
                                    if (user.mobile_phone_no && user.club_code) {

                                      if (user.confirmdata==false) {

                                        navigate('/confirmdata');
                                        return;
                                      //  navigate('/editeMember');
                                      }
                                        const customerdata = window.sessionStorage.getItem("Confirmdata");
                                      if (customerdata) {
                                        const schemewebdefaultconfirm =  window.sessionStorage.getItem("schemewebdefault");
                                          /*  if (schemewebdefaultconfirm!=null) {
                                              //  window.sessionStorage.setItem("schemewebdefault",JSON.stringify(res.response.data_club_scheme));
                                            }else if(schemewebdefaultconfirm==null){

                                                window.sessionStorage.setItem("schemewebdefault",JSON.stringify(res.response.data_club_scheme));
                                            }else{

                                                window.sessionStorage.setItem("schemewebdefault",JSON.stringify(res.response.data_club_scheme));
                                            }*/
                                            //send save data firebase
                                           //  console.log("createdata",createdata);
                                           console.log("datatotfirebase",createdata.memberAccountNo);

                                           const datatotfirebase ={
                                             "address":  createdata.address1,
                                             "address2": createdata.address2,
                                             "bc_account_no": createdata.memberAccountNo,
                                             "club_code": createdata.memberClub,
                                             "consent1": (createdata.consent1=="Yes")?(createdata.consent1)?true:false:(createdata.consent1=="No")?false:"",
                                             "consent1_date":createdata.dateConsent1,
                                             "consent2": (createdata.consent2=="Yes")?(createdata.consent2)?true:false:(createdata.consent2=="No")?false:"",
                                             "consent2_date": createdata.dateConsent2,
                                             "consent3": (createdata.consent3=="Yes")?(createdata.consent3)?true:false:(createdata.consent3=="No")?false:"",
                                             "consent3_date": createdata.dateConsent3,
                                             "consent4": (createdata.consent4=="Yes")?(createdata.consent4)?true:false:(createdata.consent4=="No")?false:"",
                                             "consent4_date": createdata.dateConsent4,
                                             "consent5": (createdata.consent5=="Yes")?(createdata.consent5)?true:false:(createdata.consent5=="No")?false:"",
                                             "consent5_date": createdata.dateConsent5,
                                             "consent6": (createdata.consent6=="Yes")?(createdata.consent6)?true:false:(createdata.consent6=="No")?false:"",
                                             "consent6_date": createdata.dateConsent5,
                                             "country": createdata.county,
                                             "city":createdata.city,
                                             "date_of_birth": createdata.dateOfBirth,
                                             "email_address": createdata.emailAddress,
                                             "first_name": createdata.firstName,
                                             "id_card_no": createdata.citizenID,
                                             "last_name": createdata.lastName,
                                             //AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
                                            "nearlyExpireDate": createdata.nearlyExpireDate,
                                            "nearlyExpirePoint": createdata.nearlyExpirePoint,
                                            //C-AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
                                             "line_user_id":  createdata.lineUserId,
                                             "mobile_phone_no": createdata.mobileNo,
                                             "post_code": createdata.postCode,
                                             "scheme_code": createdata.memberScheme,
                                             "sex": (createdata.sex=="")?"null":(createdata.sex=="Male")?"Male":(createdata.sex=="Female")?"Female":"null",
                                             "ramianing_point":createdata.totalRemainingPoints,
                                             "apistoreRegister":createdata.apistoreRegister,
                                             "scheme":createdata.memberScheme,
                                             "systemModifiedAt":(createdata.systemModifiedAt==undefined)?"":createdata.systemModifiedAt,
                                             "useLineInterface":(createdata.useLineInterface==undefined)?"":createdata.useLineInterface,
                                             "confirmdata":user.confirmdata,
                                           };
                                           const idfirebase=""+datatotfirebase.club_code+"_"+datatotfirebase.line_user_id+"";
                                           console.log("idfirebase",idfirebase);
                                            console.log("idfirebase",datatotfirebase);
                                           const userDoc = doc(db, "Member",idfirebase);
                                           console.log("userDoc",userDoc);

                                              const newFields =  datatotfirebase;
                                               updateDoc(userDoc,newFields );


                                          /* var urlcreate =connectionweb[0].Web_Api_Endpoint+connectionweb[0].Web_Api_Create_Update_Web_Member_Data;
                                           const resp =  axios.post(urlcreate,datatotfirebase,{
                                                headers: {
                                            "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                                            }
                                            })
                                            .then(resp=>{*/
                                             console.log("schemewebdefault",datatotfirebase);
                                             sessionStorage.removeItem('Customerdata');
                                             sessionStorage.setItem("Customerdata", JSON.stringify(datatotfirebase));
                                             //if (datatotfirebase.email_address=="") { //avnsd

                                             //AVCDAPNF.003  24/02/2025  Add Code for เปลี่ยนให้ nevigate ไป homepage
                                            //  if (datatotfirebase.address=="") {
                                            //       navigate('/createMember');
                                            //  }else{
                                            //      if (customerdata=="Yes") {

                                            //        navigate('/createMember');
                                            //      }else{
                                            //        // clear data
                                            //        navigate('/createMember');
                                            //        // clear data
                                            //      }
                                            //  }
                                            navigate('/homepage')
                                            //  //C-AVCDAPNF.003  24/02/2025  Add Code for เปลี่ยนให้ nevigate ไป homepage
                                             //window.sessionStorage.setItem("schemewebdefault",JSON.stringify(res.response.data_club_scheme));
                                          /*   var checkmemberfire =connectionweb[0].Web_Api_Endpoint+connectionweb[0].Web_Api_Get_Web_Member_Data+"?read=insight&userID="+linedataconvert+"&club_code="+checkcluburl(clubidweb);
                                             const rescus =  fetch(checkmemberfire, {
                                               headers: {
                                           "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                                           }
                                           })
                                           .then(results => results.json())
                                           .then(rescus=>{
                                             sessionStorage.removeItem('Customerdata');
                                             sessionStorage.setItem("Customerdata", JSON.stringify(rescus.response.data_member));
                                             if (rescus.response.data_member.email_address=="") {
                                                  navigate('/createMember');
                                             }else{
                                                 if (customerdata=="Yes") {

                                                   navigate('/createMember');
                                                 }else{
                                                   // clear data
                                                   navigate('/createMember');
                                                   // clear data
                                                 }
                                             }
                                           })
                                             .catch(err=> console.log(err))*/
                                             return;


                                            //})
                                            //.catch(err=> console.log(err))
                                            //send save data firebase


                                      }else{
                                         // update data for bc
                                         //send save data firebase
                                          console.log("createdata",createdata);
                                        const datatotfirebase ={
                                          "address":  createdata.address1,
                                          "address2": createdata.address2,
                                          "bc_account_no": createdata.memberAccountNo,
                                          "club_code": createdata.memberClub,
                                          "consent1": (createdata.consent1=="Yes")?(createdata.consent1)?true:false:(createdata.consent1=="No")?false:"",
                                          "consent1_date":createdata.dateConsent1,
                                          "consent2": (createdata.consent2=="Yes")?(createdata.consent2)?true:false:(createdata.consent2=="No")?false:"",
                                          "consent2_date": createdata.dateConsent2,
                                          "consent3": (createdata.consent3=="Yes")?(createdata.consent3)?true:false:(createdata.consent3=="No")?false:"",
                                          "consent3_date": createdata.dateConsent3,
                                          "consent4": (createdata.consent4=="Yes")?(createdata.consent4)?true:false:(createdata.consent4=="No")?false:"",
                                          "consent4_date": createdata.dateConsent4,
                                          "consent5": (createdata.consent5=="Yes")?(createdata.consent5)?true:false:(createdata.consent5=="No")?false:"",
                                          "consent5_date": createdata.dateConsent5,
                                          "consent6": (createdata.consent6=="Yes")?(createdata.consent6)?true:false:(createdata.consent6=="No")?false:"",
                                          "consent6_date": createdata.dateConsent5,
                                          "country": createdata.county,
                                          "city":createdata.city,
                                          "date_of_birth": createdata.dateOfBirth,
                                          "email_address": createdata.emailAddress,
                                          "first_name": createdata.firstName,
                                          "id_card_no": createdata.citizenID,
                                          "last_name": createdata.lastName,
                                          //AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
                                          "nearlyExpireDate": createdata.nearlyExpireDate,
                                          "nearlyExpirePoint": createdata.nearlyExpirePoint,
                                          //C-AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
                                          "line_user_id":  createdata.lineUserId,
                                          "mobile_phone_no": createdata.mobileNo,
                                          "post_code": createdata.postCode,
                                          "sex": (createdata.sex=="")?"null":(createdata.sex=="Male")?"Male":(createdata.sex=="Female")?"Female":"null",
                                          "ramianing_point":createdata.totalRemainingPoints,
                                          "apistoreRegister":createdata.apistoreRegister,
                                          "scheme":createdata.memberScheme,
                                          "scheme_code": createdata.memberScheme,
                                          "systemModifiedAt":(createdata.systemModifiedAt==undefined)?"":createdata.systemModifiedAt,
                                          "useLineInterface":(createdata.useLineInterface==undefined)?"":createdata.useLineInterface,
                                          "confirmdata":user.confirmdata,
                                        };
                                        console.log("datatotfirebase",datatotfirebase);
                                      /*  setTimeout(() => {
                                          const userDoc1 = doc(db, "Member","sTQb0YwjWYc4WAVdA6ju");
                                          const newFields1 =  datatotfirebase;
                                            updateDoc(userDoc1,newFields1 );

                                        }, 5000);*/




                                        const idfirebase=datatotfirebase.club_code+"_"+datatotfirebase.line_user_id;
                                        const userDoc = doc(db, "Member",idfirebase);
                                           const newFields =  datatotfirebase;
                                             updateDoc(userDoc,newFields );

                                      /*  var urlcreate =connectionweb[0].Web_Api_Endpoint+connectionweb[0].Web_Api_Create_Update_Web_Member_Data;
                                        const resp =  axios.post(urlcreate,datatotfirebase,{
                                             headers: {
                                         "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                                         }
                                         })
                                         .then(resp=>{*/



                                        /*  var checkmemberfire =connectionweb[0].Web_Api_Endpoint+connectionweb[0].Web_Api_Get_Web_Member_Data+"?read=insight&userID="+linedataconvert+"&club_code="+checkcluburl(clubidweb);
                                          const rescus =  fetch(checkmemberfire, {
                                            headers: {
                                        "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                                        }
                                        })
                                        .then(results => results.json())
                                        .then(rescus=>{*/
                                        //  window.sessionStorage.setItem("schemewebdefault",JSON.stringify(rescus.response.data_club_scheme));
                                          sessionStorage.removeItem('Customerdata');
                                          sessionStorage.setItem("Customerdata", JSON.stringify(datatotfirebase));
                                          console.log("check consent");
                                          //if (createdata.emailAddress=="") {  //avnsd
                                          //AVCDAPNF.003  24/02/2025  Add Code for เปลี่ยนให้ nevigate ไป homepage
                                          // if (createdata.address1=="") {
                                          //   navigate('/createMember')
                                          // }else{
                                            //check consent
                                            const cus_data = JSON.parse(""+window.sessionStorage.getItem("Customerdata"));
                                            const setupwebdefaultweb = JSON.parse(""+window.sessionStorage.getItem("setupwebdefault"));

                                            if (setupwebdefaultweb.consent1_path && cus_data.consent1 === "") {
                                                  navigate('/consentpage')
                                            }else  if (setupwebdefaultweb.consent1_require===true && cus_data.consent1 !=true) {
                                              navigate('/consentpage')
                                            }else  if (setupwebdefaultweb.consent2_code && cus_data.consent2 === "") {
                                              navigate('/consentpage')
                                            }else  if (setupwebdefaultweb.consent2_require===true && cus_data.consent2 !=true) {
                                              navigate('/consentpage')
                                            }else if (setupwebdefaultweb.consent3_code && cus_data.consent3 === "") {
                                              navigate('/consentpage')
                                            }else  if (setupwebdefaultweb.consent3_require===true && cus_data.consent3 !=true) {
                                              navigate('/consentpage')
                                            }else if (setupwebdefaultweb.consent4_code && cus_data.consent4 === "") {
                                              navigate('/consentpage')
                                            }else  if (setupwebdefaultweb.consent4_require===true && cus_data.consent4 !=true) {
                                              navigate('/consentpage')
                                            }else if (setupwebdefaultweb.consent5_code && cus_data.consent5 === "") {
                                              navigate('/consentpage')
                                            }else  if (setupwebdefaultweb.consent5_require===true && cus_data.consent5 !=true) {
                                              navigate('/consentpage')
                                            }else if (setupwebdefaultweb.consent6_code && cus_data.consent6 === "") {
                                              navigate('/consentpage')
                                            }else  if (setupwebdefaultweb.consent6_require===true && cus_data.consent6 !=true) {
                                              navigate('/consentpage')
                                            }else{
                                              navigate('/homepage')
                                            }
                                            //check consent

                                          // }
                                          //C-AVCDAPNF.003  24/02/2025  Add Code for เปลี่ยนให้ nevigate ไป homepage
                                      /*  })
                                          .catch(err=> console.log(err))*/

                                        /*  const objscheme = JSON.parse(""+window.sessionStorage.getItem("club_scheme"));
                                          Object.entries(objscheme).map((value: any[]) => {
                                              if (res.response.data_member.club_code==value[1]['club']) {
                                                if (res.response.data_member.scheme==value[1]['scheme']) {
                                                  window.sessionStorage.setItem("schemewebdefault",JSON.stringify(value[1]));
                                                }

                                              }
                                            })*/
                                        // getdetailclub(res.response.data_member.club_code,res.response.data_member.scheme);

                                        //setTimeout(() => {
                                        console.log("createdata.emailAddress",createdata.emailAddress);



                                        //  }, 2000);
                                        // })
                                        // .catch(err=> console.log(err))
                                         //send save data firebase

                                      }

                                    }else{
                                        console.log("verifymobile1");

                                         navigate('/verifymobile');

                                    }
                                  }else{

                                    if (user.checkTamp==true) {

                                      var urlTamp =connectionweb[0].Web_Api_Endpoint+"/ResendConnect?line_user_id="+linedataconvert+"&club_code="+checkcluburl(clubidweb);
                                      const resptemp =  axios.get(urlTamp,{
                                           headers: {
                                       "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                                       }
                                       })
                                       .then(resptemp=>{
                                         console.log("resend urlTamp",resptemp);
                                         var urlLicensechecktamp =connectionweb[0].BC_Api_Endpoint+connectionweb[0].BC_Api_Get_Member+"?$filter=mobileNo eq '"+user.mobile_phone_no+"' and memberClub eq '"+checkcluburl(clubidweb)+"'";
                                         console.log("urlLicense",urlLicense);

                                             var myHeaders = new Headers();
                                             myHeaders.append("Authorization", authenticateUser(connectionweb[0].BC_Api_Username,connectionweb[0].BC_Api_Password));

                                             fetch(urlLicensechecktamp, {
                                               method: 'GET',
                                               headers: myHeaders,
                                               redirect: 'follow'
                                             })
                                           .then(results => results.json())
                                           .then(createdatabc => {
                                              console.log("createdatabc.value[0]",createdatabc.value[0]);

                                             const createdata =createdatabc.value[0];
                                             //send save data firebase
                                             const datatotfirebase ={
                                               "address":  createdata.address1,
                                               "address2": createdata.address2,
                                               "bc_account_no": createdata.memberAccountNo,
                                               "club_code": createdata.memberClub,
                                               "consent1": (createdata.consent1=="Yes")?(createdata.consent1)?true:false:(createdata.consent1=="No")?false:"",
                                               "consent1_date":createdata.dateConsent1,
                                               "consent2": (createdata.consent2=="Yes")?(createdata.consent2)?true:false:(createdata.consent2=="No")?false:"",
                                               "consent2_date": createdata.dateConsent2,
                                               "consent3": (createdata.consent3=="Yes")?(createdata.consent3)?true:false:(createdata.consent3=="No")?false:"",
                                               "consent3_date": createdata.dateConsent3,
                                               "consent4": (createdata.consent4=="Yes")?(createdata.consent4)?true:false:(createdata.consent4=="No")?false:"",
                                               "consent4_date": createdata.dateConsent4,
                                               "consent5": (createdata.consent5=="Yes")?(createdata.consent5)?true:false:(createdata.consent5=="No")?false:"",
                                               "consent5_date": createdata.dateConsent5,
                                               "consent6": (createdata.consent6=="Yes")?(createdata.consent6)?true:false:(createdata.consent6=="No")?false:"",
                                               "consent6_date": createdata.dateConsent5,
                                               "country": createdata.county,
                                               //AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
                                                "nearlyExpireDate": createdata.nearlyExpireDate,
                                                "nearlyExpirePoint": createdata.nearlyExpirePoint,
                                                //C-AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
                                               "city": createdata.city,
                                               "date_of_birth": createdata.dateOfBirth,
                                               "email_address": createdata.emailAddress,
                                               "first_name": createdata.firstName,
                                               "id_card_no": createdata.citizenID,
                                               "last_name": createdata.lastName,
                                               "line_user_id":  createdata.lineUserId,
                                               "mobile_phone_no": createdata.mobileNo,
                                               "post_code": createdata.postCode,
                                               "scheme": createdata.memberScheme,
                                               "scheme_code": createdata.memberScheme,
                                               "sex": (createdata.sex=="")?"null":(createdata.sex=="Male")?"Male":(createdata.sex=="Female")?"Female":"null",
                                               "ramianing_point":"0",
                                               "confirmdata":true,
                                               "checkTamp":true,
                                                         };

                                                         console.log("datatotfirebase rawbc",datatotfirebase);
                                                         const idfirebase=datatotfirebase.club_code+"_"+datatotfirebase.line_user_id;
                                                         const userDoc = doc(db, "Member",idfirebase);
                                                            const newFields =  datatotfirebase;
                                                             updateDoc(userDoc,newFields );
                                                             sessionStorage.removeItem('Customerdata');
                                                             sessionStorage.setItem("Customerdata", JSON.stringify(datatotfirebase));
                                                          //  window.location.reload();
                                                          navigate('/homepage')
                                          /*   var urlcreate =connectionweb[0].Web_Api_Endpoint+connectionweb[0].Web_Api_Create_Update_Web_Member_Data;
                                             const resp =  axios.post(urlcreate,datatotfirebase,{
                                                  headers: {
                                              "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                                              }
                                              })
                                              .then(resp=>{
                                               console.log("creat firebase",resp);
                                              window.location.reload();

                                              })
                                              .catch(err=> console.log(err))*/
                                              //send save data firebase

                                           })
                                           .catch(err=> console.log(err))


                                       })
                                       .catch(err=> console.log(err))
                                    }else{
                                      //delete member web
                                      if (user.confirmdata==false) {

                                        navigate('/confirmdata');
                                        return;
                                      //  navigate('/editeMember');
                                    }else{
                                      const idfirebase=clubidweb+"_"+linedataconvert;
                                        const userDoc = doc(db, "Member", idfirebase);
                                             deleteDoc(userDoc);
                                             navigate('/verifymobile');
                                    }

                                    /*    const urldeletemember = connectionweb[0].Web_Api_Endpoint+connectionweb[0].Web_Api_Create_Update_Web_Member_Data+"?type=delete";
                                        const res =  axios.post(urldeletemember,{club_code: clubidweb,line_user_id:linedataconvert} ,{
                                             headers: {
                                         "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                                         }
                                       }).then(res=>{
                                         console.log("resdeletemember",res);

                                       })
                                       .catch(error => console.log('error', error));
                                       console.log("verifymobile2");
                                       navigate('/verifymobile');*/
                                       //delete
                                    }



                                  }

                                })
                                .catch(error => {

                                  popupNotconnectBc()
                                  console.log('errorbc', error)});
                            //checked member bc





                              console.log("checkcustomer",checkcustomer);
                          //  }
                        }else{
                        //  var result = newData.length;
                        //  console.log("totalcustomer",key);
                        //  console.log("checkcustomer",checkcustomer);

                        //  if (key+1==result) {
                            const cus_data = JSON.parse(""+window.sessionStorage.getItem("Customerdata"));
                            console.log("cus_data",cus_data);
                          //  if (!cus_data) {
                              console.log("verifymobile4");
                               navigate('/verifymobile');
                          //  }

                            return;
                        //  }



                        }


                    //  })


              })

              /*  if (checkcustomer==false) {
                  navigate('/verifymobile');
                }*/

                        /*  })
                          .catch(err=> {
                            navigate('/verifymobile');
                          })*/

                          })
                          .catch(err=> console.log(err))
                        });
                      })
                      .catch((err) => {
                        console.log("error", err);
                      });
                    }else{

                      liff.login();
                    }


                    //   console.log(getProfile);
                    //   setName(getProfile.displayName);
                    //   setUserLineID(getProfile.userId);
                    //   //  console.log(getProfile);
                    //   window.sessionStorage.setItem("linedata",getProfile.userId);

                    // }else{
                    //   liff.login();
                    // }
                  })
                  .catch((err) => {
                    // Error happens during initialization
                    console.log(err.code, err.message);
                  });
                }else{
                  console.log("liff nonnn");

                }
           })
           .catch(err=> console.log(err))


          //get api
          /* fetch(urldatasetup, {
            method: 'GET',
            redirect: 'follow'
          })
        .then(response => response.text())
        .then(result => {
        //   console.log("result",result);


        })
        .catch(error => console.log('error', error));*/
    });


    //    const storageRefdataconnection = ref_storage(storage, 'config_file/connection_web.json');
    //    const connectionfile = await getDownloadURL(storageRefdataconnection).then((urldataconnection) => {
    //    const resdataconnection =  fetch(urldataconnection)
    //    .then(response => response.json())
    //      .then(resdataconnection=> {
    //       //  console.log(resdataconnection);

    //     //   setdatasetup(resdataconnection.data)
    //        window.sessionStorage.setItem("connection",resdataconnection);
    //      })
    //      .catch(err=> console.log(err))
    //  });


       }
      }else{
        console.log("cunnnon");

      }
      // const clubid = window.sessionStorage.getItem("Club_Code");
      // let clubidweb= ""+clubid;
      // const liffIdline = getliffidclub(clubidweb);
    }




            async  function getdetailclub(club: any,scheme: any) {
              const objscheme = JSON.parse(""+window.sessionStorage.getItem("club_scheme"));
              Object.entries(objscheme).map((value: any[]) => {
                  if (club==value[1]['club']) {
                    if (scheme==value[1]['scheme']) {
                      window.sessionStorage.setItem("schemewebdefault",JSON.stringify(value[1]));
                    }

                  }
                })
            }
            async  function getliffidclub(club: any) {
               const avsliffid ="";
               let setupweb = window.sessionStorage.getItem('setupweb');
               console.log(typeof setupweb);
               let setupwebconvert= ""+setupweb;
               const obj = JSON.parse(setupwebconvert);
                 Object.entries(obj).map((value: any[]) => {
                     if (club==value[1]['club_code']) {
                       let liff_url = value[1]['liff_url'];
                       let result1 = liff_url.substr(21);

                       window.sessionStorage.setItem("setupwebdefault",JSON.stringify(value[1]));
                       const   avsliffid = result1;
                         window.sessionStorage.setItem("liffid",result1);


                     }
                   })


                   return avsliffid;

            }


            let stylesweb = JSON.parse(""+window.sessionStorage.getItem('stylesetup'));
            if (stylesweb) {
              const styles = {

                error_message_box_style: {
                  "backgroundColor": stylesweb.error_message_box_style.backgroud_color,
                  "border": stylesweb.error_message_box_style.border,
                  "border-color": stylesweb.error_message_box_style.border_color,
                  "border-radius": stylesweb.error_message_box_style.border_radius,
                  "color": stylesweb.error_message_box_style.font_color,
                  "font-family": stylesweb.error_message_box_style.font_name,
                  "font-size": stylesweb.error_message_box_style.font_size,
                  "font-weight": stylesweb.error_message_box_style.font_weight,
                },


              };
            }else{
                const styles = {
              error_message_box_style: {
                "backgroundColor": "#EFF2F5",
                "border": "0.5px",
                "border-color": "#C9C9C9",
                "border-radius": "6px",
                "color": "#2A2A2A",
                "font-family": "Kanit",
                "font-size": "22px",
                "font-weight": "Bold",
              },


            };
            }


            const styless = {

              error_message_box_style: {
                "backgroundColor": "#EFF2F5",
                "border": "0.5px",
                "border-color": "#C9C9C9",
                "border-radius": "6px",
                "color": "#2A2A2A",
                "font-family": "Kanit",
                "font-size": "22px",
                "font-weight": "Bold",
              },


            };













// console.log(styles);

  /*  function checkcustomerlogin() {
      const clubid = window.sessionStorage.getItem("Club_Code");

      let clubidweb= ""+clubid;

      if (clubidweb) {
          console.log(userLineID);
        if (userLineID) {
          console.log("sucdd");

        }
      }
    }*/




  	return (


          <div className='card card-homepage Login-Loading'>
          <div id="root" className="d-flex flex-column flex-root"></div><div id="splash-screen" className="splash-screen"><span>Loading ...</span></div><div id="root-modals"></div>

          {}
          {isOpenNotconnectBc && <Popup
            content={<>
                <div className="box" style={stylesweb?styless.error_message_box_style:styless.error_message_box_style}>
              <img src={failedlogo} alt="failedlogo" className="img-correct"/>
              <p>ระบบไม่สามารถใช้งานได้ในขณะนี้
                  กรุณาทำรายการภายหลังอีกครั้ง
                  ขออภัยในความไม่สะดวก
                  Error Code : 004
                  </p>

          </div>
            </>}
            handleClose={togglePopupNotconnectBc}
          />}
          {isOpenNotapp && <Popup
            content={<>
                <div className="box" style={stylesweb?styless.error_message_box_style:styless.error_message_box_style}>
              <img src={failedlogo} alt="failedlogo" className="img-correct"/>
              {/*avnsd*/}
            {/*<p>กรุณาเข้าสู่ระบบผ่าน line app </p>*/}
            <p>กรุณาเข้าใช้งานผ่าน Line Application</p>
            {/*avnsd*/}

          </div>
            </>}

          />}
            </div>



  	)
}
